module.exports = __webpack_public_path__ + "img/empreendimento-logo-17.35effce7.png";